import moment from "moment";

class Util {
  private static util: Util;

  public static instance() {
    if (!this.util) {
      this.util = new Util();
    }
    return this.util;
  }

  public isArrayPopulated(array: any): boolean {
    if (array) {
      if (array.length > 0) {
        return true;
      }
    }
    return false;
  }

  public getDateFromString(dt: string): Date {
    dt = dt.replace("/", "-");
    return moment(dt, "YYYY-MM-DD").toDate();
  }

  public parseDate(dt: string): Date {
    dt = dt.replace("/", "-");
    return moment(dt, "DD-MM-YYYY").toDate();
  }

  public dateFormat(dt: Date): string {
    var data = moment(dt).format("DD/MM/YYYY");
    return data;
  }

  public isValidDate(dt: string): boolean {
    if(dt!=null){

      dt = dt.replace("/", "-");
    
      var data  = moment(dt, "DD-MM-YYYY"); 
      return data.isValid();
    }
    return false;    
  }

  public isValidTime(hr: string): boolean {
    if(hr!=null && hr.length == 5){
      var arr = hr.split(':');
      var hora = Number(arr[0]);
      var min = Number(arr[1]);
      if ((hora >= 0 && hora < 24) && (min >= 0 && min < 60)){
        return true;
      }
    }
    return false;    
  }
}

export default Util.instance();
